import { Col, Collapse, Row, Tooltip } from "antd";
import React, { useState } from "react";
import TagComponent from "../../../../biblio/TagComponent";
import { PrinterOutlined, DownloadOutlined } from "@ant-design/icons";
import AddCommitmentAttachmentModal from "../CommitmentAttachmentModal";
import dayjs from "dayjs";

interface Props {
  requests: any;
}

const RegistrationUniversityCollapse = ({
  requests,
}: Props) => {
  const handleDownload = (attachment: any) => {
    if (attachment && attachment.datas && attachment.filename) {
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;base64,${attachment.datas}`;
      link.download = attachment.filename;
      link.click();
    }
  };
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [scholarship, setScholarship] = useState<any | null>(null);
  return (
    <div className="takaful--collapse-profile-container">
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم التسجيل
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ التسجيل
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={7}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المستفيد
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  style={{ paddingRight: "1.5rem" }}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--date-format">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المستفيد
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element && element?.partner_id[1]}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="80%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element && element?.stage_id[1]}
                    />
                  </Col>
                  <Col
                    xxl={1}
                    xl={1}
                    lg={1}
                    md={1}
                    sm={12}
                    xs={24}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    {!element?.signed_commitment_attachment && (
                      <Tooltip
                        overlayClassName="takaful--share-tooltip"
                        placement="bottom"
                        title="إرفاق ميثاق الإلتزام"
                        getPopupContainer={(triggerNode) =>
                          triggerNode.closest(
                            ".takaful--header-profile-container"
                          ) || document.body
                        }
                      >
                        <PrinterOutlined
                          className="takaful--print-icon takaful--service-print-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsModalVisible(true);
                            setScholarship(element);
                          }}
                        />
                      </Tooltip>
                    )}
                  </Col>
                </Row>
              </div>
            }
          >
            <Row
              className={`takaful--content-profile-box1`}
              justify={"space-between"}
              gutter={16}
            >
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  التخصص بالثانوية :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.high_school_speciality}
                </span>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  الجامعة التي تم القبول عليها :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.university_id && element?.university_id[1]}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  معدل القدرات :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.skills_rate}
                </span>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  المعدل النسبة الموزونة :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.calculated_rate}
                </span>
              </Col>

              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  معدل التراكمي :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.accumulated_rate}
                </span>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  المعدل التحصيلي :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.achievement_rate}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  رقم الطلب :
                </p>
              </Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.request_number}
                </span>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              ></Col>
              <Col
                xxl={7}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={24}
                className="takaful--content-profile-col"
              ></Col>
              {!element?.signed_commitment_attachment &&
                Array.isArray(element?.commitment_attachment_ids) &&
                element.commitment_attachment_ids.length > 0 && (
                  <>
                    <Col
                      xxl={4}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={24}
                      className="takaful--content-profile-col"
                    >
                      <p
                        className="takaful--content-services-request-p"
                        style={{ color: "red" }}
                      >
                        الرجاء تنزيل ميثاق الإلتزام :
                      </p>
                    </Col>
                    <Col
                      xxl={7}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={24}
                      className="takaful--content-profile-col"
                    >
                      <DownloadOutlined
                        className="takaful--download-icon takaful--service-download-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownload(element.commitment_attachment_ids[0]);
                        }}
                      />
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={24}
                      className="takaful--content-profile-col"
                    ></Col>
                    <Col
                      xxl={7}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={24}
                      className="takaful--content-profile-col"
                    ></Col>
                  </>
                )}
            </Row>
            {element.refuse_reason !== false && (
              <Row gutter={16} className={`takaful--content-profile-box1`}>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    سبب الرفض :
                  </p>
                </Col>
                <Col
                  xxl={18}
                  xl={18}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.refuse_reason}
                  </span>
                </Col>
              </Row>
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
      <AddCommitmentAttachmentModal
        setIsModalVisible={setIsModalVisible}
        scholarship={scholarship}
        type="university"
        isModalVisible={isModalVisible}
      />
    </div>
  );
};

export default RegistrationUniversityCollapse;
